export const actionTypePrefix = '@@ReportPageModal';
export const reduxKey = '@@ReportPageModal';

export enum ReportSectionTypes {
  Home = 'home',
  Inappropriate = 'inappropriate',
  SpamMalwareWarez = 'spam-malware-warez',
  IpViolation = 'ip-violation',
  ThirdPartyIp = 'third-party-ip',
  FirstPartyIp = 'first-party-ip',
  SomethingElse = 'something-else',
  Mature = 'mature',
  Underage = 'underage',
  Explicit = 'explicit',
  Block = 'block',
  Misplaced = 'misplaced',
  Abuse = 'abuse',
  SelfHarm = 'self-harm',
  Spam = 'spam',
  Malware = 'malware',
  Warez = 'warez',
  MonetizedAi = 'monetized-ai',
  Sharing = 'sharing',
}

export const ReportSectionForms = {
  [ReportSectionTypes.ThirdPartyIp]: 30,
  [ReportSectionTypes.FirstPartyIp]: 39,
  [ReportSectionTypes.Mature]: 4,
  [ReportSectionTypes.Underage]: 28,
  [ReportSectionTypes.Explicit]: 37,
  [ReportSectionTypes.Misplaced]: 2,
  [ReportSectionTypes.Abuse]: 3,
  [ReportSectionTypes.SelfHarm]: 45,
  [ReportSectionTypes.Spam]: 44,
  [ReportSectionTypes.Malware]: 32,
  [ReportSectionTypes.Warez]: 33,
  [ReportSectionTypes.MonetizedAi]: 46,
  [ReportSectionTypes.Sharing]: 47,
};

export const DeprecatedQuestions = [
  57, // proof of age
  96, // checkboxes of sexual content descriptions
];
